/**
 * Badge Component
 *
 * Small status indicators and labels
 * - Multiple variants (default, success, warning, danger, info)
 * - Different sizes
 * - Optional dot indicator
 * - Optional dismiss button
 */

import React from "react";
import PropTypes from "prop-types";
import "./Badge.scss";

export const Badge = ({
  children,
  variant = "default",
  size = "medium",
  dot = false,
  onDismiss,
  onClick,
  className = "",
  title,
}) => {
  const badgeClasses = [
    "badge",
    `badge--${variant}`,
    `badge--${size}`,
    dot && "badge--with-dot",
    onDismiss && "badge--dismissible",
    onClick && "badge--clickable",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <span className={badgeClasses} onClick={onClick} title={title}>
      {dot && <span className="badge__dot" />}
      <span className="badge__content">{children}</span>
      {onDismiss && (
        <button
          type="button"
          className="badge__dismiss"
          onClick={onDismiss}
          aria-label="Dismiss"
        >
          ×
        </button>
      )}
    </span>
  );
};

Badge.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf([
    "default",
    "success",
    "warning",
    "danger",
    "info",
    "purple",
  ]),
  size: PropTypes.oneOf(["small", "medium", "large"]),
  dot: PropTypes.bool,
  onDismiss: PropTypes.func,
  onClick: PropTypes.func,
  className: PropTypes.string,
  title: PropTypes.string,
};

export default Badge;
